const isEmptyObj = (obj) => {
  let empty = true
  for (const key in obj) {
    const att = obj[key]
    if (Object.keys(att).length) {
      for (const attKey in att) {
        const attVal = att[attKey]
        if (attVal === true) {
          empty = false
        }
      }
    } else {
      if (att === true) {
        empty = false
      }
    }
  }

  return empty
}

export default isEmptyObj
